var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */
import { Component, CustomElement, Event, html, Prop } from '@sick-davinci/ce-decorators';
import { style } from './PlotterToolbar.style';
import { IconRef } from '@sick-davinci/basic-elements';
import { ICON_INFO, ICON_PAUSE, ICON_PLAY, ICON_RESET, ICON_ZOOM_IN, ICON_ZOOM_OUT } from './PlotterIcons.js';
export let PlotterToolbarButton;

(function (PlotterToolbarButton) {
  PlotterToolbarButton["Play"] = "play";
  PlotterToolbarButton["Pause"] = "pause";
  PlotterToolbarButton["PlayPause"] = "play-pause";
  PlotterToolbarButton["Reset"] = "reset";
  PlotterToolbarButton["ZoomIn"] = "zoom-in";
  PlotterToolbarButton["ZoomOut"] = "zoom-out";
  PlotterToolbarButton["Info"] = "info";
  PlotterToolbarButton["Separator"] = "separator";
})(PlotterToolbarButton || (PlotterToolbarButton = {}));

export
/**
 * A toolbar for the plotter.
 *
 * @ignore
 *
 * This custom element is for internal use only.
 */
let PlotterToolbar = (_dec = Component({
  tag: 'davinci-plotter-toolbar',
  style,
  dependencies: [IconRef]
}), _dec2 = Prop({
  reflectAsAttribute: false
}), _dec3 = Reflect.metadata("design:type", Object), _dec4 = Prop({
  type: Boolean
}), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop({
  type: Boolean
}), _dec7 = Reflect.metadata("design:type", Boolean), _dec8 = Event(), _dec9 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class PlotterToolbar extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "buttons", _descriptor, this);

    _initializerDefineProperty(this, "play", _descriptor2, this);

    _initializerDefineProperty(this, "disabled", _descriptor3, this);

    _initializerDefineProperty(this, "buttonClick", _descriptor4, this);
  }

  render() {
    return html`
      <div class="container">
        ${this._renderButtons()}
      </div>
    `;
  }

  _renderButtons() {
    return html`${this.buttons.map(button => this._renderButton(button))}`;
  }

  _renderButton(button) {
    if (button === PlotterToolbarButton.Separator) {
      return html`
        <div class="separator"></div>`;
    }

    let selected = false;
    let icon = '';

    switch (button) {
      case PlotterToolbarButton.Play:
        selected = this.play === true;
        icon = ICON_PLAY;
        break;

      case PlotterToolbarButton.Pause:
        selected = this.play === false;
        icon = ICON_PAUSE;
        break;

      case PlotterToolbarButton.PlayPause:
        icon = this.play ? ICON_PAUSE : ICON_PLAY;
        break;

      case PlotterToolbarButton.Reset:
        icon = ICON_RESET;
        break;

      case PlotterToolbarButton.ZoomIn:
        icon = ICON_ZOOM_IN;
        break;

      case PlotterToolbarButton.ZoomOut:
        icon = ICON_ZOOM_OUT;
        break;

      case PlotterToolbarButton.Info:
        icon = ICON_INFO;
        break;

      default:
        // eslint-disable-next-line
        console.error(`unknown toolbar-button type <${button}>`);
        break;
    }

    return html`
      <button ?disabled="${this.disabled}" class="toolbarButton" @pointerdown="${event => this.buttonClick.emit({
      event,
      button
    })}">
        <davinci-icon-ref class="icon" ?selected="${selected}" .src="${icon}"></davinci-icon-ref>
      </button>`;
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "buttons", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [PlotterToolbarButton.Info, PlotterToolbarButton.Separator, PlotterToolbarButton.Play, PlotterToolbarButton.Pause];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "play", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "buttonClick", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
